import { create } from 'zustand';

import { ExtendCarbonCredit } from '@/libs/api';
import apiClient from '@/libs/api/client';

import { runTask } from './modal';

type CarbonCreditState = {
  carbonCredit: ExtendCarbonCredit;
  getCarbonCredit: (id: number) => void;
};

export const useCarbonCreditStore = create<CarbonCreditState>((set) => ({
  carbonCredit: {} as ExtendCarbonCredit,

  getCarbonCredit: async (id: number) => {
    await runTask(async () => {
      const response = await apiClient.carbonCredit.carbonCreditRetrieve(id);
      set({ carbonCredit: response });
    });
  }
}));
